document.addEventListener('DOMContentLoaded', function () {

  /* Mobil fő menü */
  var toggle = document.querySelector('.mobile-toggle');
  var menu = document.querySelector('.mega ul');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var isOpen = menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  /* Kezdőlap hero banner – több csúszka, automatikus váltás */
  var heroSlider = document.getElementById('HeroSlider');
  if (heroSlider) {
    var slides = heroSlider.querySelectorAll('.hero-slide');
    var dots = heroSlider.querySelectorAll('.hero-dot');
    var prevBtn = heroSlider.querySelector('.hero-arrow.prev');
    var nextBtn = heroSlider.querySelector('.hero-arrow.next');
    var current = 0;
    var timer = null;
    var autoplayMs = parseInt(heroSlider.getAttribute('data-autoplay'), 10) || 5000;

    function goTo(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('active', i === current);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === current);
      });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(next, autoplayMs);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (slides.length > 1) {
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
      });
      heroSlider.addEventListener('mouseenter', stopAutoplay);
      heroSlider.addEventListener('mouseleave', startAutoplay);
      startAutoplay();
    }
  }

  /* Mobil almenük (2. és 3. szint) le/felnyitása */
  document.querySelectorAll('.mega .dropdown-toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var li = btn.closest('li');
      if (!li) return;
      var isOpen = li.classList.contains('open');
      // Ugyanazon a szinten lévő testvér elemeket bezárjuk, hogy ne torlódjon egymásra a menü
      var parentList = li.parentElement;
      if (parentList) {
        parentList.querySelectorAll(':scope > li.open').forEach(function (sibling) {
          if (sibling !== li) {
            sibling.classList.remove('open');
            var siblingBtn = sibling.querySelector(':scope > .dropdown-toggle');
            if (siblingBtn) siblingBtn.setAttribute('aria-expanded', 'false');
          }
        });
      }
      li.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.querySelectorAll('.prod-scroll').forEach(function (scroller) {
    scroller.setAttribute('tabindex', '0');
  });

  /* --- Termékoldal: galéria miniatűrök --- */
  var mainImg = document.getElementById('ProductMainImage');
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg && thumb.dataset.full) { mainImg.src = thumb.dataset.full; }
    });
  });

  /* --- Mennyiség stepper (delegált esemény, dinamikusan betöltött kártyákon is működik) --- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest ? e.target.closest('.qty-minus') : null;
    var plus = e.target.closest ? e.target.closest('.qty-plus') : null;
    if (!minus && !plus) return;
    var stepper = (minus || plus).closest('.qty-stepper');
    if (!stepper) return;
    var input = stepper.querySelector('input[type=number]');
    if (!input) return;
    if (minus) {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    } else {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    }
    input.dispatchEvent(new Event('change'));
  });

  /* --- Termékoldal: variáns (méret/szín stb.) váltás – készlet, ár, gomb frissítése --- */
  (function () {
    var dataEl = document.getElementById('ProductVariantsData');
    var selects = document.querySelectorAll('.variant-option-select');
    if (!dataEl || !selects.length) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    function currentSelection() {
      var vals = [];
      selects.forEach(function (sel) { vals.push(sel.value); });
      return vals;
    }

    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < vals.length; j++) {
          if (v.options[j] !== vals[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function applyVariant(variant) {
      var available = !!(variant && variant.available);

      document.querySelectorAll('#ProductForm input[name="id"], .sticky-atc input[name="id"]').forEach(function (input) {
        input.value = variant ? variant.id : '';
      });

      var addBtn = document.getElementById('ProductAddBtn');
      var stickyBtn = document.querySelector('.sticky-atc button[type="submit"]');
      [addBtn, stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        btn.classList.toggle('btn-disabled', !available);
        btn.textContent = available ? 'Kosárba teszem' : 'Elfogyott';
      });

      var stockMsg = document.getElementById('ProductStockMsg');
      if (stockMsg) stockMsg.style.display = available ? 'none' : 'block';

      if (variant) {
        var priceEl = document.getElementById('ProductPriceMain');
        if (priceEl) priceEl.textContent = variant.price;
        var stickyPriceEl = document.getElementById('StickyPrice');
        if (stickyPriceEl) stickyPriceEl.textContent = variant.price;

        var compareEl = document.getElementById('ProductComparePrice');
        var saveEl = document.getElementById('ProductSavePct');
        if (variant.compare_at_price) {
          if (compareEl) { compareEl.textContent = variant.compare_at_price; compareEl.style.display = ''; }
          if (saveEl) { saveEl.textContent = '-' + variant.save_pct + '%'; saveEl.style.display = ''; }
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        applyVariant(findVariant(currentSelection()));
      });
    });
  })();

  /* Mennyiség szinkronizálása a sticky mobil sávval, ha van */
  var mainQty = document.getElementById('ProductQty');
  if (mainQty) {
    mainQty.addEventListener('change', function () {
      document.querySelectorAll('.sticky-atc input[name="quantity"]').forEach(function (el) {
        el.value = mainQty.value;
      });
    });
  }

  /* --- Termékajánló (PDP) betöltése AJAX-on --- */
  var recos = document.getElementById('ProductRecos');
  if (recos && recos.dataset.url) {
    fetch(recos.dataset.url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('.product-recos');
        recos.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
      })
      .catch(function () { /* csendben elnyomjuk, ha nincs elég adat az ajánláshoz */ });
  }

  /* --- Predikt keresés --- */
  var searchInput = document.getElementById('SiteSearchInput');
  var searchResults = document.getElementById('SiteSearchResults');
  var searchTimer;
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { searchResults.classList.remove('open'); searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'search/suggest.json'
          : '/search/suggest.json';
        fetch(url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<div class="r-empty">Nincs találat erre: "' + q.replace(/</g, '&lt;') + '"</div>';
            } else {
              searchResults.innerHTML = products.map(function (p) {
                var img = p.featured_image ? p.featured_image.url : (p.image || '');
                return '<a class="result-item" href="' + p.url + '">' +
                  (img ? '<img src="' + img + '&width=100" loading="lazy" alt="">' : '') +
                  '<div class="r-info"><h6>' + p.title + '</h6><div class="p">' + (p.price || '') + '</div></div>' +
                  '</a>';
              }).join('') + '<div class="r-viewall" onclick="document.getElementById(\'SiteSearchForm\').submit()">Összes találat megtekintése →</div>';
            }
            searchResults.classList.add('open');
          })
          .catch(function () { searchResults.classList.remove('open'); });
      }, 250);
    });

    document.addEventListener('click', function (e) {
      if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) {
        searchResults.classList.remove('open');
      }
    });
  }

  /* --- Mobil szűrő panel a kollekció oldalon --- */
  var openFilters = document.getElementById('OpenFilters');
  var closeFilters = document.getElementById('CloseFilters');
  var filtersPanel = document.getElementById('CollectionFilters');
  if (openFilters && filtersPanel) openFilters.addEventListener('click', function () { filtersPanel.classList.add('open'); });
  if (closeFilters && filtersPanel) closeFilters.addEventListener('click', function () { filtersPanel.classList.remove('open'); });

  /* --- Kosárba tétel AJAX-on: "Kosárba téve" felugró ablak (notino.hu mintára) --- */
  var routes = window.themeRoutes || {};
  var cartCountEl = document.getElementById('CartCount');
  var modal = document.getElementById('CartAddedModal');
  var modalBody = document.getElementById('CartModalBody');

  function money(amount) {
    // Ez a bolt HUF-ot 0 tizedesjegyes valutaként kezeli: a cart API is
    // a tényleges forintösszeget adja vissza (nem *100-zal szorozva), így itt sem osztunk.
    var forint = Math.round(amount || 0);
    return forint.toLocaleString('hu-HU') + ' Ft';
  }
  function withWidth(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function escapeHtml(s) {
    return (s || '').toString().replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function openCartModal() {
    if (!modal) return;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  }
  function closeCartModal() {
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  }
  if (modal) {
    modal.querySelectorAll('[data-close]').forEach(function (el) {
      el.addEventListener('click', closeCartModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartModal();
    });
  }

  function renderCartModal(item) {
    if (!modalBody) return;
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="cm-item-variant">' + escapeHtml(item.variant_title) + '</div>' : '';
    var imgSrc = item.image || (item.featured_image && item.featured_image.url) || '';
    var img = imgSrc ? withWidth(imgSrc, 160) : '';

    modalBody.innerHTML =
      '<h3 id="CartModalTitle" class="cm-title">✓ Kosárba téve</h3>' +
      '<div class="cm-item">' +
        (img ? '<img class="cm-item-img" src="' + img + '" alt="' + escapeHtml(item.product_title) + '">' : '') +
        '<div class="cm-item-info">' +
          '<div class="cm-item-title">' + escapeHtml(item.product_title) + '</div>' +
          variantLine +
          '<div class="cm-item-qty">' + item.quantity + ' db</div>' +
          '<div class="cm-item-price">' + money(item.line_price) + '</div>' +
        '</div>' +
        '<div class="cm-actions">' +
          '<a href="' + (routes.cart || '/cart') + '" class="btn">Ugrás a kosárba</a>' +
          '<button type="button" class="btn outline" data-close>Tovább vásárolok</button>' +
        '</div>' +
      '</div>' +
      '<div class="cm-recos" id="CartModalRecos">' +
        '<h4>A vásárlók szintén vásárolták</h4>' +
        '<div class="cm-recos-grid"></div>' +
      '</div>';

    modalBody.querySelectorAll('[data-close]').forEach(function (el) {
      el.addEventListener('click', closeCartModal);
    });

    // Ajánlott termékek betöltése a hozzáadott termékhez
    if (routes.productRecommendations && item.product_id) {
      var recoUrl = routes.productRecommendations + '?section_id=product-recommendations&product_id=' + item.product_id + '&limit=4';
      fetch(recoUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var cards = tmp.querySelectorAll('.prod-card');
          var grid = modalBody.querySelector('.cm-recos-grid');
          var recosWrap = modalBody.querySelector('#CartModalRecos');
          if (!cards.length || !grid) { if (recosWrap) recosWrap.style.display = 'none'; return; }
          cards.forEach(function (card) { grid.appendChild(card); });
        })
        .catch(function () {
          var recosWrap = modalBody.querySelector('#CartModalRecos');
          if (recosWrap) recosWrap.style.display = 'none';
        });
    }

    openCartModal();
  }

  function showCartError(message) {
    if (!modalBody) return;
    modalBody.innerHTML =
      '<h3 class="cm-title">Hiba történt</h3>' +
      '<p class="cm-error">' + escapeHtml(message) + '</p>' +
      '<div class="cm-actions"><button type="button" class="btn outline" data-close>Bezárás</button></div>';
    modalBody.querySelectorAll('[data-close]').forEach(function (el) {
      el.addEventListener('click', closeCartModal);
    });
    openCartModal();
  }

  /* FONTOS: capture fázisban figyelünk (a harmadik paraméter `true` a lenti
     addEventListener végén), nem buborékban. A Shopify web-pixels-manager minden
     <form action="/cart/add"> elemre saját `submit` figyelőt tesz, és csak akkor
     NEM küld `product_added_to_cart` eseményt, ha az esemény ekkor már
     defaultPrevented. Buborék fázisban a form saját (Shopify) figyelője előbb fut,
     mint a mi document szintű figyelőnk, így a preventDefault() elkésik: a Shopify
     kilövi az eseményt a form submitre, majd másodszor is a lenti fetch('/cart/add')
     válaszára -> a Meta Pixel AddToCart (és a Google/TikTok add_to_cart) duplán megy.
     Capture fázisban a document figyelője fut elsőként, így a preventDefault() időben
     megtörténik, és csak a fetch-alapú esemény marad -> pontosan egy AddToCart. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('ajax-cart-form')) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var originalLabel = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Hozzáadás…'; }

    var formData = new FormData(form);

    fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          var msg = (result.data && result.data.description) || 'Nem sikerült a kosárba tenni a terméket.';
          showCartError(msg);
          return;
        }
        // Kosár darabszám frissítése a fejlécben
        fetch(routes.cartJson || '/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cartCountEl) {
              cartCountEl.textContent = cart.item_count;
              cartCountEl.style.display = cart.item_count > 0 ? '' : 'none';
            }
          })
          .catch(function () {});
        renderCartModal(result.data);
      })
      .catch(function () {
        showCartError('Nem sikerült a kosárba tenni a terméket. Próbáld újra.');
      })
      .finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalLabel; }
      });
  }, true);

  /* Megjegyzés: a kosár oldal ingyenes szállítás sávja mostantól kiszolgáló oldalon (Liquid)
     számolódik a main-cart.liquid-ben, mert a /cart.js API total_price mezője itt eltérő
     léptékben tér vissza, mint a Liquid `money` szűrő — ez okozott egy hibás "elérve" jelzést. */

  /* --- Kosár oldal: kedvezménykód alkalmazása --- */
  var couponInput = document.getElementById('CartCouponInput');
  var couponBtn = document.getElementById('CartCouponApply');
  if (couponInput && couponBtn) {
    var applyCoupon = function () {
      var code = couponInput.value.trim();
      if (!code) return;
      var root = routes.root || '/';
      window.location.href = root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
    };
    couponBtn.addEventListener('click', applyCoupon);
    couponInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); applyCoupon(); }
    });
  }

  /* --- Kosár oldal: "Ezt is szereted majd" ajánlott termékek --- */
  var cartRecosGrid = document.getElementById('CartRecosGrid');
  var cartRecosWrap = document.getElementById('CartRecos');
  if (cartRecosGrid && routes.productRecommendations) {
    fetch(routes.cartJson || '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        if (!cartData.items || !cartData.items.length) { throw new Error('empty cart'); }
        var pid = cartData.items[0].product_id;
        var url = routes.productRecommendations + '?section_id=product-recommendations&product_id=' + pid + '&limit=4';
        return fetch(url).then(function (res) { return res.text(); });
      })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var cards = tmp.querySelectorAll('.prod-card');
        if (!cards.length) { throw new Error('no recos'); }
        cards.forEach(function (card) { cartRecosGrid.appendChild(card); });
      })
      .catch(function () { if (cartRecosWrap) cartRecosWrap.style.display = 'none'; });
  }
});
